module.exports = __webpack_public_path__ + "img/ic_food_function_canteen_tabes_img2.da6a4385.png";